import { Spacing } from '@persona-id/design-tokens';
import { CircleXInverseIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import { Z_INDICES } from 'dashboard/styles/variables';
import { Heading, Paragraph } from 'design-system/components/Text';

const UnusableScreenWarningContainer = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
`;

const UnusableScreenWarning = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-width: 80%;
  margin: auto;
`;

const StyledWarningIcon = styled(CircleXInverseIcon).attrs({ size: 50 })`
  path {
    fill: ${({ theme }) => theme.color.primary.white};
  }
`;

const StyledWarningHeading = styled(Heading).attrs({ size: 'md', color: 'inverse' })`
  margin: ${Spacing[1]} 0;
`;

const FadeInContainer = styled.div`
  @keyframes fade-in {
    0% {
      opacity: 0;
    }

    50% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  animation-name: fade-in;
  animation-iteration-count: 1;
  animation-duration: 200ms;
  animation-fill-mode: forwards;
  z-index: ${Z_INDICES.modal};
  position: absolute;
  width: 100%;
  height: 100%;
`;

const UnusuableScreenEditorWarning = () => (
  <FadeInContainer>
    <UnusableScreenWarningContainer>
      <UnusableScreenWarning>
        <StyledWarningIcon title='Screen editor unusable' />
        <StyledWarningHeading>Your browser window is too small</StyledWarningHeading>
        <Paragraph color='inverse'>
          Try collapsing the main nav, or resize your browser window, to continue using the screen
          editor
        </Paragraph>
      </UnusableScreenWarning>
    </UnusableScreenWarningContainer>
  </FadeInContainer>
);

export default UnusuableScreenEditorWarning;
